import React from "react";
import { TableBody, TableRow, TableCell, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const FileTableRows = ({ files, onDeleteClick, formatFileSize, canDelete }) => {
  return (
    <TableBody>
      {files.length === 0 ? (
        <TableRow>
          <TableCell colSpan={4} align="center">No files found.</TableCell>
        </TableRow>
      ) : (
        files.map((file) => (
          <TableRow key={file.Id} sx={{ "&:nth-of-type(even)": { backgroundColor: "#f9f9f9" } }}>
            <TableCell>{file.Filename}</TableCell>
            <TableCell>{new Date(file.Created_at * 1000).toLocaleString()}</TableCell>
            <TableCell>{formatFileSize(file.Bytes)}</TableCell>
            {canDelete && (
            <TableCell align="right">
              <IconButton onClick={() => onDeleteClick(file)}>
                <DeleteIcon color="error" />
              </IconButton>
            </TableCell>
            )}
          </TableRow>
        ))
      )}
    </TableBody>
  );
};

export default FileTableRows;